import * as React from "react";

/** Study note icon — used for 単語テスト / 単語学習 sections */
export const IconStudyNote = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#clip0_study_note)">
      <path
        d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM8 14H6V12H8V14ZM8 11H6V9H8V11ZM8 8H6V6H8V8ZM15 14H10V12H15V14ZM18 11H10V9H18V11ZM18 8H10V6H18V8Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_study_note">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
